module.exports = __webpack_public_path__ + "img/img_032@2x.b6a7bc89.png";